import React from 'react'
import { Row, Col, Card, ListGroup } from '@themesberg/react-bootstrap'

const ModulePermissions = ({ subModulePermissions }) => {
  const clonedSubModulePermissions = JSON.parse(JSON.stringify(subModulePermissions))

  return (
    <div className='p-3'>
      <Card className='my-4'>
        <Card.Header className='fw-bold py-3 px-4 text-center'>
          Submodule Permissions
        </Card.Header>
        <Card.Body>
          <Row className='gy-3'>
            {Object.keys(clonedSubModulePermissions).map((moduleKey) => {
              const module = clonedSubModulePermissions[moduleKey]
              if (module.enabled) {
                return (
                  <Col lg={4} md={6} sm={12} className='d-flex' key={moduleKey}>
                    <Card className='w-100 permissions-card'>
                      <Card.Header className='fw-bold py-3 px-4'>{module.name}</Card.Header>
                      <ListGroup variant='flush'>
                        {module.subModules.map((subModule) =>
                          subModule.enabled
                            ? (
                              <ListGroup.Item
                                key={subModule.key}
                                className='d-flex justify-content-between align-items-center py-2 px-3'
                              >
                                <small>{subModule.name}</small>
                                <svg width='16' height='16' viewBox='0 0 16 16'>
                                  <path
                                    id='circle-check-solid'
                                    d='M0,8a8,8,0,1,1,8,8A8,8,0,0,1,0,8ZM11.619,6.619a.875.875,0,0,0-1.237-1.237L7,8.762,5.619,7.381A.875.875,0,0,0,4.381,8.619l2,2a.877.877,0,0,0,1.237,0Z'
                                    fill='#05a677'
                                  />
                                </svg>
                              </ListGroup.Item>
                              )
                            : null
                        )}
                      </ListGroup>
                    </Card>
                  </Col>
                )
              }
              return null
            })}
          </Row>
        </Card.Body>
      </Card>
    </div>
  )
}

export default ModulePermissions
